import appConfig from '@/features/app/constants/app-config';

export default [
  {
    id: 'essential', // 'essential-cookies
    // name: 'Essential',
    // description:
    // 'Essential cookies are necessary for the website to function properly. This category only includes cookies that ensures basic functionalities and security features of the website. These cookies do not store any personal information.',
    required: true,
    cookies: [
      {
        id: 'auth-token',
        // name: 'Auth Token',
        // description:
        //   'Stores the user authentication token to keep the user logged in across different pages.',
        cookie_names: [appConfig.authTokenKey],
        required: true,
      },
      {
        id: 'access-token-expires-at',
        cookie_names: [appConfig.accessTokenExpireDateKey],
        required: true,
      },
      {
        id: 'refresh-token-expires-at',
        cookie_names: [appConfig.refreshTokenExpireDateKey],
        required: true,
      },
      {
        id: 'remember-me',
        cookie_names: [appConfig.rememberMeKey],
        required: true,
      },
      {
        id: 'php-session',
        // name: 'PHP Session',
        // description: 'Preserves user session state across page requests.',
        cookie_names: ['PHPSESSID'],
        required: true,
      },
    ],
  },
  {
    id: 'statistics',
    // name: 'Statistics',
    // description:
    //   'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information.',
    required: false,
    cookies: [
      {
        id: 'matomo',
        // name: 'Matomo',
        // description:
        //   'Collects information about the users and their activity on the website for analytics and reporting purposes.',
        cookie_names: ['MATOMO_SESSID', '_pk_id', '_pk_ses'],
        required: false,
        defaultValue: true,
      },
    ],
  },
] satisfies Array<{
  id: string;
  required: boolean;
  cookies: Array<{
    id: string;
    cookie_names: string[];
    required: boolean;
    defaultValue?: boolean;
  }>;
}>;
